// Pixel-Münzen-Icon für UI-Flächen (Sidebar, Popups, Spielseite).
import { useRef, useEffect } from "react";
import { drawSprite, COIN_SPRITE, COIN_PALETTE } from "./pixelArt";

export default function CoinIcon({ size = 16, className = "" }) {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingEnabled = false;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawSprite(ctx, COIN_SPRITE, COIN_PALETTE, 0, 0, size / 8);
  }, [size]);
  return (
    <canvas
      ref={ref}
      width={size}
      height={size}
      className={`inline-block shrink-0 ${className}`}
      style={{ imageRendering: "pixelated" }}
      aria-hidden="true"
    />
  );
}
